import classes from './ErpForUtilityCompanies.module.scss'
import React, { useEffect } from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import { Link } from "react-scroll";
import eRoadImg from '../../../media/projects/e-road.webp'
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const ErpForUtilityCompanies = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
                        
    const title = t('erpForUtilityCompanies.title')
    const description = t('erpForUtilityCompanies.text', {returnObjects: true})

    const solutionsBlocks= t('erpForUtilityCompanies.solutionsBlocks', {returnObjects: true})
    
    const blackBlocks = t('erpForUtilityCompanies.blackBlocks', {returnObjects: true})

    const benefitBlocks= t('erpForUtilityCompanies.benefitBlocks', {returnObjects: true})

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('erpForUtilityCompanies.Faq.left', {returnObjects: true}),
        right: t('erpForUtilityCompanies.Faq.right', {returnObjects: true}),
    };

    return (
        <>
            <Helmet>
                <title>
                    ERP for Utility Companies ⚡ Smart Billing & Infrastructure | Goteco
                </title>
                <meta
                    name="description"
                    content="Optimize your utility business with ERP! 🚀 Manage billing, assets & compliance seamlessly. Future-proof your infrastructure. Get a free consultation today!"
                />
                <link rel="canonical" href="https://go-te.co/solutions/erp-for-utility-companies" />
            </Helmet>
            <main>
            <Heading title={title} description={description} maxWidth={700}/>

            <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('erpForUtilityCompanies.solutionsBlocksTitle')}</h2>
                </div>
                <div>
                    {solutionsBlocks.map(({ image, title, text }) => (
                        <div className={classes.block} key={title}>
                            <img alt={title} src={require(`./media/${image}`)}/>
                            <div className={classes.content}>
                                <h5>{title}</h5>
                                <p>{text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section className={`section--dark-gray ${classes['capabilities']}`} id={"nav-light"}>
                <h2>{t('erpForUtilityCompanies.blackBlocksTitle')}</h2>
                <div className={classes.blocks}>
                    {blackBlocks.map(({ text, icon }) => (
                        <BlackCardWithIcon key={icon} iconName={icon} text={text}/>
                    ))}
                </div>
            </section>

            <section className={`section--white ${classes['benefits']}`} id={"nav-dark"}>
                <div>
                    <h2>{t('erpForUtilityCompanies.benefitBlocksTitle')}</h2>
                </div>
                <div>
                    {benefitBlocks.map(({ title, text }) => (
                        <BlueGradientBlock title={title} text={text} key={title}/>
                    ))}
                </div>
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('erpForUtilityCompanies.Faq.title')} questions={questions}/>
            </section>

            <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                <div className={classes.content}>
                    <div className={classes['text-block']}>
                        <h2>{t('erpForUtilityCompanies.useCase')}</h2>
                        <div className={classes.text}>
                            <img src={eRoadImg} alt="Use Case"/>
                            <p>{t('erpForUtilityCompanies.useCaseSubtitle')}</p>
                        </div>
                    </div>
                    <div className={classes.actions}>
                        <span>{t('erpForUtilityCompanies.useCaseText')}</span>
                        <Link className={classes.link} smooth={true} to={'contact'}>{t('erpForUtilityCompanies.useCaseButton')}</Link>
                    </div>
                </div>
                <img className={classes.img} src={eRoadImg} alt="Use Case"/>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard
                    title={t('erpForUtilityCompanies.formCard.title')}
                    subtitle={t('erpForUtilityCompanies.formCard.subtitle')}
                    message={t('erpForUtilityCompanies.formCard.message')}
                    buttonText={t('erpForUtilityCompanies.formCard.buttonText')}
                    labels={t('erpForUtilityCompanies.formCard.labels', {returnObjects: true})}
                    top={3}
                    id='contact'
                />
            </section>
        </main>
        </>
    );
};

export default ErpForUtilityCompanies;